"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Reject = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.254 3.332a5.69 5.69 0 0 0-7.922 7.922l7.922-7.922zm-6.507 9.336a5.69 5.69 0 0 0 7.92-7.921l-7.92 7.92zm8.91-10.325A8 8 0 1 1 2.341 13.657 8 8 0 0 1 13.656 2.343z",
  className: "fill"
}));

var _default = Reject;
exports.default = _default;